import "./dataTableMassLocalSite.scss";
import {DataGrid, enUS, GridToolbar} from "@mui/x-data-grid";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import useFetch from "../../../hooks/useFetch";
import newRequest from "../../../context/newRequest";

const DataTableMassLocalSite = ({columns, ticketId}) => {
    const location = useLocation();
    const path = location.pathname.split("/")[1];
    const [list, setList] = useState([]);
    const { data, loading, error } = useFetch(`/v1/ticketsite/query?nomor_tt=TT${ticketId}`);


    useEffect(() => {
        setList(data);
    }, [data]);

    const handleDelete = async (id, token) => {
        try {
            console.log("Hapus data loading")
            await newRequest.delete(`/${path}/mass/${id}` , {
                    headers: {
                        'Authorization': `$Bearer ${token}`
                    }
                }
            );
            setList(data.filter((item) => item.id !== id));

        } catch (err) {}
    };


    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <Link to={`/ticketsite/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div className="viewButton">View</div>
                        </Link>


                    </div>
                );
            },
        },
    ];
    return (
        <div className="datatable">
            <DataGrid
                className="datagrid"
                rows={list}
                columns={columns.concat(actionColumn)}
                localeText={enUS.components.MuiDataGrid.defaultProps.localeText}
                components={{
                    Toolbar: GridToolbar
                }}
                pageSize={10}
                rowsPerPageOptions={[10]}
                checkboxSelection
                getRowId={(row) => row.id}
            />
        </div>
    );
};

export default DataTableMassLocalSite;
